<template>
  <a v-if="(lat && lng) || url"
     :href="urlValue"
     class="streetview"
     target="_blank"
  >
    <slot>
      <img v-if="imageSize"
           class="streetview__image"
           :src="`/streetview.jpg?size=${imageSize}&amp;location=${lat},${lng}&amp;heading=${course}`"
           @load="loading = false"
      />
    </slot>

    <span v-if="loading" class="content-loader">
      <Spinner />
    </span>
  </a>
</template>
<script setup>
import {computed, ref} from "vue";
import Spinner from "@/js/Elements/Spinner.vue";
import {useStore} from "vuex";

const props = defineProps({
  lat: Number,
  lng: Number,
  course: Number,
  imageSize: String,
  url: String,
});
const store = useStore();
const courseValue = computed(() => Math.round(props.course));
const loading = ref(!!props.imageSize);
const urlValue = computed(() => {
  return props.url || `https://maps.google.com/maps?q=&layer=c&cbll=${props.lat},${props.lng}&cbp=11,${courseValue.value ? courseValue.value + ',' : ''}0,0,0`;
});
</script>
<style lang="scss" scoped>
@import "@/css/functions";
@import "@/css/variables";

.streetview {
  position: relative;
  &__image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>